import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = {
  key: 0,
  class: "error"
}
const _hoisted_8 = { class: "modal-footer text-right" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]

import { computed, toRef } from 'vue'
    import type { ProjectClonerViewModel } from '@Projects/Components/ProjectCloner'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectCloner',
  props: {
    viewModel: {}
  },
  emits: ["clone-project"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.opened ?? false)
    const cloning = computed(() => vm.value.cloning)
    const nameError = computed(() => vm.value.nameError)

    const name = computed<string | null>({
        get: () => vm.value.cloneName,
        set: val => { vm.value.cloneName = val }
    })

    // ---------------- methods ----------------

    function handleFormSubmit()
    {
        vm.value.cloning = true
        emit('clone-project', vm.value.sourceId, name.value)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "modal-title" }, "Clone", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("form", {
                  id: "project-cloner-form",
                  onSubmit: _withModifiers(handleFormSubmit, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[2] || (_cache[2] = _createElementVNode("label", null, "Clone Name (2-100 characters):", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                      type: "text",
                      class: "form-control",
                      required: "",
                      minlength: "2",
                      maxlength: "100"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        name.value,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    (nameError.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(nameError.value), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ], 32 /* NEED_HYDRATION */)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: close,
                  disabled: cloning.value,
                  class: "btn btn-secondary"
                }, "Close", 8 /* PROPS */, _hoisted_9),
                _createElementVNode("button", {
                  type: "submit",
                  form: "project-cloner-form",
                  disabled: cloning.value,
                  class: "btn btn-primary"
                }, _toDisplayString(cloning.value ? 'Cloning...' : 'Clone'), 9 /* TEXT, PROPS */, _hoisted_10)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})